module.exports = __webpack_public_path__ + "static/media/DrCrystalFok.1f75ac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/DrCrystalFok.jpg
// module id = 207
// module chunks = 0